import Vidle from "v-idle";
import Vue from "vue";

Vue.use(Vidle);
